<template>
  <b-container class="container-fluid d-flex h-100 flex-column" style="margin-top:90px;">
    <b-row>
      <div class="offset-4"></div>
      <h2>Already Have an Account?</h2>
    </b-row>
    <b-row>
      <div class="offset-4"></div>
      <div class="col-md-6">
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
      </div>
    </b-row>
    <b-row class="">
      <b-col cols="10" offset="1" xl="4" offset-xl="4" class="align-self-center">
        <b-card class="shadow" style="background-color: lightgrey">
          <h5 class="text-center" style="color: #333333;">Login</h5>
          <LoginForm v-on:setData="setData" v-on:loginfailed="loginfailed" v-bind:token="token"/>
        </b-card>
      </b-col>
    </b-row>

    <b-modal v-model="modal" id="login-modal" ok-only>{{$t('LOGIN_PROBLEM')}}</b-modal>


  </b-container>
</template>
<script>
import LoginForm from "./LoginForm";

export default {
  components: {
    LoginForm
  },
  data : function() {
    return {
      modal : false
    };
  },
  props: ["token"],
  methods: {
    setData : function(token) {
      this.$emit('setData', token);
    },
    loginfailed: function() {
      this.modal = true;
    }
  }
};
</script>